import { render, staticRenderFns } from "./LegalSubdivision.vue?vue&type=template&id=5ffe74a0&scoped=true&"
import script from "./LegalSubdivision.vue?vue&type=script&lang=js&"
export * from "./LegalSubdivision.vue?vue&type=script&lang=js&"
import style0 from "./LegalSubdivision.vue?vue&type=style&index=0&id=5ffe74a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffe74a0",
  null
  
)

export default component.exports